'use client';

import { classNames } from '@bytel/product-wall/helpers';
import { Text, TextLevels, TextMarkup, TextProps, TypographyBold } from '@bytel/trilogy-react';

import { formatPrice } from '@helpers/wording';

interface InlinePriceProps extends TextProps {
    amount?: number;
    period?: string;
    markup?: never;
    strike?: boolean;
}

export function InlinePrice({
    amount: _amount,
    level = TextLevels.ONE,
    typo = TypographyBold.TEXT_WEIGHT_SEMIBOLD,
    period,
    strike = false,
    className = '',
    ...args
}: Readonly<InlinePriceProps>) {
    const amount = formatPrice(_amount ?? 0);
    const accessibilityLabel = period ? `${amount}€ par ${period}` : undefined;

    return (
        <Text
            level={level}
            markup={TextMarkup.SPAN}
            typo={typo}
            accessibilityLabel={accessibilityLabel}
            marginless
            className={classNames(className, 'price', strike ? 'strike' : '')}
            {...args}
        >
            {amount}
            {period ? `/${period}` : ''}
        </Text>
    );
}
